module.exports = __webpack_public_path__ + "img/cont_icon03.35fef423.svg";